// main
import { useHistory } from "react-router-dom";

import ContentFormatXZ from "../content/webc/content-format-xz";

import WebbDividerMedium from "../content/webb/webb-divider-md";
import WebbDividerSmall from "../content/webb/webb-divider-sm";


import icon from "../media/icon.png";

const data = [
  {name: 'Email', icon:'bi-envelope', link: 'account/mail', actv: true},
  {name: 'Mobile', icon:'bi-phone', link: 'account/mobile', actv: true},
  {name: 'Web3', icon:'bi-globe2', link: 'account/web3', actv: false}
]

export default function Main () {
  
  const history = useHistory();

  return(
    <>
      <ContentFormatXZ 
        head='Main'
        link={``}
        form= 'mini'
        data= {
          <>
            <div className="text-center">
            <WebbDividerMedium />
            <WebbDividerMedium />
            <img src={icon} height="42" width="42" alt="..."></img>
            <WebbDividerMedium />

            <h1 className="fw-bold text-color-main" style={{fontSize:'1.9rem'}}>
              {process.env.REACT_APP_WEBB_SITE_NAME}
            </h1>
            <p className="lead text-muted">
              {process.env.REACT_APP_WEBB_SITE_LINE}
            </p>

            <div className="" style={{height:'33vh'}}></div>
            <p className="text-color-tone">Connect Your Account</p>

            <div className="d-flex p-3 py-0 bg-wite rounded-wd hilite"
              style={{cursor:'pointer'}}
              onClick={() => history.push('/account/mail')}
            >
              <div className="py-1">
                <i className="lead bi-briefcase text-color-main m-0 pb-0 mb-0"  style={{fontSize:"1.5rem"}}></i>
              </div>
              <div className="ps-2 py-2">
                <p className="m-0 mt-1">Login with Email</p>
              </div>
              <div className="ms-auto text-end py-2 mt-1">
                <i className="bi-chevron-right text-color-tone m-0" ></i>
              </div>
            </div>

            </div>
          </>
        } 
      />
    </>
  )
}